import React from 'react';
import BaseClass from '../common/baseClass';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues } from "../../redux/actions";
import { filterModelSelector } from "../../redux/selectors";

import "../../css/animate/css/animate.min.css"; // Lo stiamo usando???
const common = require('../common/common');
const env = require("../../config.js").default;

class FilterModels extends BaseClass {
	constructor(props) {
		super(props);
		this.selectId = this.props.isModal ? "select_model_modal" : "select_model"
	}

	updateModel() {
		const $ = window.$;
		$("#select_model_loader").fadeIn("fast");
		$("#select_model_error").hide();
		$('#' + this.selectId).attr("disabled", true);
		this.props.changeValues({ renewMutex: { modelli: false }, dataList: { modelli: {} } });
		common.apiCall(env.BACKEND + "epc/get_products/", "GET", { zprod: this.state.filtersState.marca }, true).then((modelli) => {
			if (modelli.error === false) {
				$("#select_model_loader").fadeOut("fast");
				$('#' + this.selectId).removeAttr("disabled");
				modelli.map(function (entry) {
					entry.visibile = true;
					return entry;
				});
				this.props.changeDatalist("modelli", modelli);
			} else {
				$("#select_model_error").fadeIn("fast");
				$("#erroreApiModello").fadeIn("fast").html('<i class="fas fa-exclamation-triangle"></i> ' + common.getTrad("Nessun modello trovato."));
				$("#select_model_loader").fadeOut("fast");
			}
		});
	}

	componentWillMount() {
		this.updateStateWithStoreProps();
		if (this.state.renewMutex.modelli)
			this.updateModel();
	}

	resetModel = () => {
		var modelli = [];
		var i = 0;
		modelli = this.state.dataList.modelli;
		for (i = 0; i < modelli.length; i++) {
			modelli[i].visibile = true;
		}
	}

	componentDidMount(props) {
		const $ = window.$;
		var dropdownParent = this.props.isModal ? $('#modalItem') : null;
		$('#' + this.selectId).on('select2:select select2:unselect', (e) => {
			e.preventDefault();
			var nuovoModello = $(e.target).val();
			this.props.changeValues({ filtersState: { modello: nuovoModello, tavola: ""/*, telaio: ""*/ }, renewMutex: { tavole: true, tavoleApp: true }, dataList: { tavole: {} } });
		});

		function matchCustom(params, data) {
			if ($.trim(params.term) === '') {
				return data;
			}
			var keywords = (params.term).split(/[.+-/_ ]/);

			for (var i = 0; i < keywords.length; i++) {
				if (((data.text).toUpperCase()).indexOf((keywords[i]).toUpperCase()) === -1)
					return null;
			}
			return data;
		}
		$('#' + this.selectId).select2({
			matcher: matchCustom,
			language: common.getLanguage(),
			dropdownParent: dropdownParent,
			placeholder: common.getTrad("Seleziona un modello"),
			allowClear: true,
			sorter: function (data) {
				/* Sort data using lowercase comparison */
				return data.sort(function (a, b) {
					a = a.text.toLowerCase();
					b = b.text.toLowerCase();
					if (a > b) {
						return 1;
					} else if (a < b) {
						return -1;
					}
					return 0;
				});
			}
		});

		$(window).resize(function () {
			$('.select2').css('width', "100%");
		});
		$('.select2').css('width', "100%");

	}

	componentWillReceiveProps(nextProps) {
		this.updateStateWithStoreProps(nextProps);
	}

	componentDidUpdate(prevProps) {
		const $ = window.$;
		if (this.state.filtersState.modello !== undefined && this.state.filtersState.modello !== null && this.state.filtersState.modello !== "") {
			$("select#" + this.selectId + "select_model option[value='" + this.state.filtersState.modello + "']").attr("selected", true);
		}
		$("select#" + this.selectId).val(this.state.filtersState.modello).trigger("change");
		this.updateStateWithStoreProps();

		if (prevProps.store.filtersState.marca !== this.state.filtersState.marca)
			this.updateModel();
		if ((this.state.filtersState.cmoto || this.state.dataList.applicazioni.length > 0) && !$("select#" + this.selectId).val()) {
			$("select#" + this.selectId).focus();
			$("#modelSelContainer").addClass("select-focus");
			// $("#ricerca_filtro_modello_pulse").addClass("animate__animated animate__bounce");
		}
		if (this.state.filtersState.modello)
			$("#modelSelContainer").removeClass("select-focus");
	}

	render(props) {
		const $ = window.$;
		var i = 0;
		var modelli = [];
		var div_class = this.props.isModal ? "row-margin-standard row" : "col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12" 
		if (this.state.dataList.applicazioni.length > 0 || this.state.filtersState.cmoto !== '') {
			var count = 0;

			if (this.state.filtersState.cmoto) {
				modelli = this.state.dataList.modelli;
				for (i = 0; i < modelli.length; i++) {
					if (this.state.filtersState.cmoto === modelli[i].CMOTO)
						modelli[i].visibile = true;
					else
						modelli[i].visibile = false;
				}
				this.props.changeValues({ renewMutex: { modelliApp: false }, dataList: { modelli: modelli } });
			}
			else if (this.state.dataList.applicazioni.length > 0) {
				modelli = this.state.dataList.modelli;
				for (i = 0; i < modelli.length; i++) {
					modelli[i].visibile = common.object_value_in_array(this.state.dataList.applicazioni, "CMOTO", modelli[i].CMOTO) > -1;
					if (this.state.dataList.modelli[i].visibile) {
						var CMOTO = this.state.dataList.modelli[i].CMOTO;
						count += 1;
					}
				}

				if (count <= 1) {
					$("select#" + this.selectId + " option[value='" + CMOTO + "']").attr("selected", true);
					$("select#" + this.selectId).trigger("change");
					this.props.changeValues({ filtersState: { modello: CMOTO } });
				}

				this.props.changeValues({ renewMutex: { modelliApp: false }, dataList: { modelli: modelli } });
			}
		} else {
			this.resetModel();
			this.props.changeValues({ renewMutex: { modelliApp: false } });
		}

		return (
			<div className={div_class + " row-eq-height"} role="alert" id="ricerca_filtro_modello">
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_filtro" id="ricerca_filtro_modello_pulse">
					{this.props.isModal ? (
						<>
						<span>{common.getTrad("Modello")}</span>
						</>
					
					) : (
						<>
						<h4 id={`label-${this.selectId}`}>{common.getTrad("Ricerca Modello")} <figure className="svg" src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-veicoli.svg"} title={common.getTrad("Ricerca Modello")} alt={common.getTrad("Ricerca Modello")}></figure></h4>
						<hr />
						</>
					)}
					<div id="modelSelContainer" className="form-group selectSwCustom">
						<div id="select_model_loader" className="select_loader" style={{ display: this.state.renewMutex.modelli || Object.keys(this.state.dataList.modelli).length <= 0 ? "block" : "none" }}>
							<i className="fas fa-spinner fa-spin"></i>
						</div>
						<div id="select_model_error" className="select_loader" style={{ display: "none" }}>
							<i className="fas fa-exclamation-triangle text-danger"></i>
						</div>
						<select name={this.selectId} className="form-control select_modelli" id={this.selectId} aria-labelledby={`label-${this.selectId}`} defaultValue={this.state.filtersState.modello ? this.state.filtersState.modello : ""} disabled={this.state.renewMutex.modelli || Object.keys(this.state.dataList.modelli).length <= 0}>
							<option></option>
							{this.state.dataList.modelli ?
								Object.keys(this.state.dataList.modelli).map((index, key) => {
									return this.state.dataList.modelli[Object.keys(this.state.dataList.modelli)[key]] !== false && this.state.dataList.modelli[Object.keys(this.state.dataList.modelli)[key]].visibile ?
										<option key={key} value={this.state.dataList.modelli[index].CMOTO} >
											{this.state.dataList.modelli[index].DMOBA.toUpperCase()}
										</option>
										:
										""
								})
								:
								<></>
							}
						</select>
					</div>
					<div style={{ display: 'none' }} id="erroreModello" className="alert alert-warning" role="alert"></div>
					<div style={{ display: 'none' }} id="erroreApiModello" className="alert alert-danger" role="alert"></div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	const store = filterModelSelector(state);
	return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, changeValues })(FilterModels);
//export default FilterModels;
